import React from 'react';
import propTypes from 'prop-types';
import {
    Button,
    Form,
    Modal
} from 'shared-ui';
import { useCreateObservationType } from 'data/observationType';
import styles from '../ObservationTypeScreen.module.scss';

type Props = {
    className?: string;
    onClose?: () => void;
    onCompletion?: (observationTyperId: number) => void;
};

const CreateCustomerModal: React.FC<Props> = ({
    className,
    onClose,
    onCompletion
}: Props) => {
    const { mutateAsync: createType, isLoading: isCreating } = useCreateObservationType();
    const [labelState, setLabelState] = React.useState<string>('');

    const formIsValid = React.useMemo(() => labelState.trim().length > 0, [labelState]);

    const handleLabelChange = React.useCallback((value: string) => {
        setLabelState(value);
    }, []);

    const handleCloseClick = React.useCallback(() => {
        onClose?.();
    }, [onClose]);

    const handleCreateClick = React.useCallback(async () => {
        if (!formIsValid) return;

        const newTypeId = await createType({ label: labelState });

        onCompletion?.(newTypeId);
        onClose?.();
    }, [labelState, createType, formIsValid, onClose, onCompletion]);

    return (
        <Modal
            className={`${styles['modal']} ${className} modal-flex`}
            backdrop
            centered
        >
            <Modal.Header>
                <Modal.Title>
                    Créer un type de suivi
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Form.Group controlId="observationType-label" className="col">
                        <Form.Label>Nom du type de suivi</Form.Label>
                        <Form.Input
                            value={labelState}
                            maxlength={50}
                            autocomplete="off"
                            readOnly={isCreating}
                            onChange={handleLabelChange}
                        />
                    </Form.Group>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={isCreating}
                    onClick={handleCloseClick}
                >
                    Annuler
                </Button>
                <Button
                    color="primary"
                    disabled={!formIsValid}
                    pending={isCreating}
                    onClick={handleCreateClick}
                >
                    Créer le type de suivi
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

CreateCustomerModal.propTypes = {
    className: propTypes.string,
    onClose: propTypes.func,
    onCompletion: propTypes.func
};

CreateCustomerModal.defaultProps = {
    className: undefined,
    onClose: undefined,
    onCompletion: undefined
};

export default CreateCustomerModal;
